export const AgentRotationRangeTypeEnum = {
    PriceRange: {key: 1, value: 'Price Range'},
    Size: {key: 2, value: 'Size'},
    Bathroom: {key: 3, value: 'Bathroom'},
    Bedroom: {key: 4, value: 'Bedroom'},
}